import styled, { css } from 'styled-components';

export type MessageType = 'success' | 'warning' | 'error';

export const MessageContainer = styled.div<{ type: MessageType }>`
	${({ theme, type }) => css`
		width: 100%;
		border-radius: ${theme.radii.default};
		padding: 15px 22px;
		font-size: ${theme.fontSizes.default};
		font-weight: ${theme.fontWeights.medium};
		${type === 'success' && `background-color: ${theme.colors.success[100]};`}
		${type === 'success' && `border: solid 1px ${theme.colors.success[300]};`}

		${type === 'warning' && `background-color: ${theme.colors.warning[100]};`}
		${type === 'warning' && `border: solid 1px ${theme.colors.warning[300]};`}

		${type === 'error' && `background-color: ${theme.colors.error[100]};`}
		${type === 'error' && `border: solid 1px ${theme.colors.error[300]};`}
	`};
`;

export const MessageContent = styled.div`
	display: grid;
	place-content: center;
	max-width: 80%;
`;
